<script lang="ts">
import Plane from "@/Components/Generics/Plane.vue";
import NavigationLink from "@/Components/NavigationLink.vue";
import { defineComponent } from "vue";

export default defineComponent({
    name: "MainFooter",
    components: {
        Plane,
        NavigationLink,
    },
    props: {},
    emits: [],
    data: () => ({}),
    computed: {
        routes() {
            return [
                {
                    hrefRoute: "main",
                    pageRoute: "/",
                    title: this.$trans("navigation.nav_find"),
                },
                {
                    hrefRoute: "search.index",
                    pageRoute: "/search",
                    title: this.$trans("navigation.nav_search"),
                },
                {
                    hrefRoute: "economic-sectors",
                    pageRoute: "/economic-sectors",
                    title: this.$trans("navigation.nav_economic_sectors"),
                },
                {
                    hrefRoute: "qualifications",
                    pageRoute: "/qualifications",
                    title: this.$trans("navigation.nav_qualifications"),
                },
                {
                    hrefRoute: "events",
                    pageRoute: "/events",
                    title: this.$trans("navigation.nav_events"),
                },
                {
                    href: "mailto:contact@deinjobfuchs.de",
                    title: this.$trans("navigation.nav_contact"),
                    notALink: true,
                },
                {
                    hrefRoute: "dashboard",
                    pageRoute: "/login",
                    title: this.$trans("navigation.nav_login").split(" / ").join("&nbsp;&nbsp;/&nbsp;&nbsp;"),
                },
                {
                    hrefRoute: "imprint",
                    pageRoute: "/imprint",
                    title: this.$trans("footer.imprint"),
                },
                {
                    hrefRoute: "data-privacy-statement",
                    pageRoute: "/dataprivacystatement",
                    title: this.$trans("footer.data_privacy_statement"),
                },
            ];
        },
    },
    methods: {},
});
</script>

<template>
    <footer>
        <div class="content-width">
            <Plane class="plane plane--offset" :rounded="true" :rounded-bottom="false">
                <div class="plane-content flex flex--valign-c flex--halign-c flex--gap-20 flex--wrap">
                    <NavigationLink v-for="route in routes" :key="route.title" :href-route="route.hrefRoute" :href="route.href" :page-route="route.pageRoute" :title="route.title" :not-a-link="route.notALink" :uppercase="true" />
                </div>
            </Plane>
            <Plane class="plane plane--no-padding" :rounded="true" :rounded-bottom="false" :darker="true">
                <div class="text text--accent-gray-b text--medium text--center">
                    &copy; {{ new Date().getFullYear() }} {{ $trans("footer.copyright") }}
                    <span class="version">· v{{ $page.props.appVersion }}</span>
                </div>
            </Plane>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
footer {
    // min-height: rem(100);
    position: relative;

    .content-width {
        min-height: rem(100);
        margin: 0 auto;
        padding-top: rem(30);

        .plane {
            padding-left: rem(180);
            padding-right: rem(180);

            .plane-content {
                row-gap: rem(10);
                width: 100%;
                padding: rem(20) 0;
            }

            &.plane--offset {
                padding-bottom: rem(40);
                margin-bottom: rem(-20);
            }

            &.plane--no-padding {
                padding-left: 0;
                padding-right: 0;
            }

            .version {
                opacity: 0.6;
                font-size: 0.85em;
            }
        }
    }
}

@include media-breakpoint-down(md) {
    footer {
        .content-width {
            .plane {
                padding-left: 0;
                padding-right: 0;

                .plane-content {
                    flex-direction: column;
                    row-gap: rem(8);
                    flex-wrap: nowrap;
                }
            }
        }
    }
}
</style>
